import React from "react";
import { Dropdown, DropdownMenu } from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { LOGGED_ADMIN, paths } from "../../../../../common/constants";
import selectors from "./selectors";
import actions from "../../actions";
import PropTypes from "prop-types";
import { AWS_STATIC_ENDPOINT } from "../../../../../common/constants";

class DropDownMenu extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      admin: null,
    };
    this.handleDropDownMenu = this.handleDropDownMenu.bind(this);
    this.logout = this.logout.bind(this);
  }

  logout() {
    const {
      history: { replace },
      logout,
    } = this.props;

    logout().then(() => {
      replace(paths.client.ADMIN_LOGIN);
    });
  }

  componentDidMount() {
    const admin = JSON.parse(localStorage.getItem(LOGGED_ADMIN));
    this.setState({ admin });
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.isAdminDetailUpdated === true &&
      JSON.stringify(nextProps.admin) !== JSON.stringify(this.props.admin)
    ) {
      if (nextProps.admin) {
        const { data } = nextProps.admin;
        localStorage.setItem(LOGGED_ADMIN, JSON.stringify(data));
        this.setState({ admin: data });
      }
    }
  }

  toggle() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }

  handleDropDownMenu(event) {
    const {
      history: { push },
    } = this.props;
    if (event.target.id === "account_setting") {
      push(paths.client.ADMIN_SETTING);
    } else if (event.target.id === "account_signout") {
      this.logout();
    }
  }

  render() {
    return (
      <Dropdown
        className="profile-menu"
        isOpen={this.state.dropdownOpen}
        toggle={this.toggle}
      >
        <div className="avatar-view dropdown-toggle" data-toggle="dropdown">
          <img
            className="avatar-circle"
            src={
              this.state.admin
                ? this.state.admin.avatar
                : AWS_STATIC_ENDPOINT + "/images/avatar.png"
            }
          ></img>
          <div className="profile-name">
            {this.state.admin ? this.state.admin.email : "ADMIN"}
          </div>
        </div>
        <DropdownMenu>
          <div
            onClick={this.handleDropDownMenu}
            id="account_setting"
            className="dropdown-menu-item"
          >
            <i className="fa fa-cog"></i>Settings
          </div>
          <div
            onClick={this.handleDropDownMenu}
            id="account_signout"
            className="dropdown-menu-item"
          >
            <i className="fa fa-sign-out"></i>Sign out
          </div>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

DropDownMenu.propTypes = {
  logout: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool,
  data: PropTypes.object,
  isAdminDetailUpdated: PropTypes.bool,
  admin: PropTypes.object,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default connect(selectors, {
  ...actions.admin,
  ...actions.authentication,
})(withRouter(DropDownMenu));



// WEBPACK FOOTER //
// ./client/react/Admin/components/DropDownMenu/index.js